import React from "react";
import { createPortal } from "owa-react-dom";
import loc from "owa-localize";
import { observer } from "owa-mobx-react";
import { StatusBarTargetContext } from "./StatusBarTargetContext";
import { itemsLabel, itemsTooltip, unreadLabel, unreadTooltip } from "./StatusBar.locstring.json";
import { statusBarFields } from "./StatusBar.scss";

type StatusBarCountsProps = {
    items: number;
    unread?: number;
};

/** Renders item and unread counts in the shared status bar through a portal. */
export const StatusBarCounts: React.FunctionComponent<StatusBarCountsProps> = observer(function StatusBarCounts({ items, unread }) {
    const target = React.useContext(StatusBarTargetContext);
    if (!target) {
        return null;
    }
    
    return createPortal(<div className={statusBarFields}>
                <span role="status" title={loc(itemsTooltip)}>
                    {loc(itemsLabel, items)}
                </span>
                {unread !== undefined && (<span role="status" title={loc(unreadTooltip)}>
                        {loc(unreadLabel, unread)}
                    </span>)}
            </div>, target);
}, "StatusBarCounts");
